import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessProductInvoiceHandler {
	url: any;
	token: any;
	
	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	getBusinessInvoice(params){	
		return new Promise( (resolve, reject) => {
		  	this.url = this.globals.dataUrl + 'businessProductInvoice' + 
		                                      '/page/' + params.page +
		                                      '/size/' + params.size;

			this.storage.get('loginData').then((loginData) => {
			    this.http.get(
			        this.url,
			        this.httpHelper.configOptionsWithToken(loginData.access_token)
			    )
			    .map(res => res.json())
			    .subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
			   	);  
			});
		});    	
  	}

	getBusinessInvoiceDetail(params){	
		return new Promise( (resolve, reject) => {
		  	this.url = this.globals.dataUrl + 'businessProductInvoice/detail/' +  params.id;

			this.storage.get('loginData').then((loginData) => {
			    this.http.get(
			        this.url,
			        this.httpHelper.configOptionsWithToken(loginData.access_token)
			    )
			    .map(res => res.json())
			    .subscribe(
					data => {
						resolve(data.Data);
					},
					err => {reject(err)}
			   	);  
			});
		});    	
  	}  	
}



// WEBPACK FOOTER //
// ./src/providers/business-product-invoice-handler.ts